import { CadFeatureMap } from '@mark43/cad-api';
import React from 'react';

export const EnabledFeaturesContext = React.createContext<CadFeatureMap | undefined>(undefined);
